import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';

import { Tax } from '../../../models/tax';

import { NotyService } from '../../../services/common/noty.service';
import { TaxService } from '../../../services/accounting/tax.service';
import { UserService } from '../../../services/users/user.service';

@Component({
  selector: 'app-tax-form',
  templateUrl: './tax-form.component.html',
  styleUrls: ['./tax-form.component.scss'],
})
export class TaxFormComponent implements OnInit {
  formOptions: any = {
    chart_of_accounts: [],
    frequencies: [],
    types: [],
    ways: [],
  };

  formSubmitted: boolean = false;
  formSubmitting: boolean = false;

  tax: Tax = new Tax();

  constructor(private route: ActivatedRoute, private location: Location, private notyService: NotyService, private router: Router, private taxService: TaxService, private userService: UserService) {}

  // Component lifecycle events
  ngOnInit() {
    this.userService.navbarComponent.setTaxesMenu();
    this.taxService.formOptions().then((formOptions) => {
      if (formOptions) this.formOptions = formOptions;
      if (this.route.snapshot.params['id'])
        this.taxService.edit(Number(this.route.snapshot.params['id'])).then((tax) => {
          this.tax = tax;
          if (this.tax.type == 'LiabilityTax') this.formOptions.chart_of_accounts = this.formOptions.liabilities_chart_of_accounts;
          else this.formOptions.chart_of_accounts = this.formOptions.expenses_chart_of_accounts;
        });
      else {
        this.tax.chart_of_account_id = this.formOptions.liabilities_default_chart_of_account_id;
        if (this.formOptions.frequencies[0]) this.tax.frequency = this.formOptions.frequencies[0].value;
        if (this.formOptions.ways[0]) this.tax.way = this.formOptions.ways[0].value;
        if (this.formOptions.liabilities_chart_of_accounts) this.formOptions.chart_of_accounts = this.formOptions.liabilities_chart_of_accounts;
      }
    });
  }

  // Component methods
  back() {
    this.location.back();
  }

  save(formValid: boolean) {
    this.formSubmitted = true;
    if (!formValid) return;
    this.formSubmitting = true;
    this.taxService
      .save(this.tax)
      .then((response_json) => {
        this.formSubmitting = false;
        if (response_json.success) {
          this.notyService.notify(response_json.text || 'Tax saved successfully', 'success');
          this.router.navigateByUrl('/taxes');
        } else this.notyService.notify(response_json.text || 'Error saving tax', 'error');
      })
      .catch(() => {
        this.formSubmitting = false;
        this.notyService.notify('Error saving tax', 'error');
      });
  }

  typeChanged() {
    if (this.tax.type == 'LiabilityTax') {
      this.formOptions.chart_of_accounts = this.formOptions.liabilities_chart_of_accounts;
      this.tax.chart_of_account_id = this.formOptions.liabilities_default_chart_of_account_id;
    } else {
      this.formOptions.chart_of_accounts = this.formOptions.expenses_chart_of_accounts;
      this.tax.chart_of_account_id = this.formOptions.expenses_default_chart_of_account_id;
    }
  }
}
